export default function cloudinaryLoader({
  src,
  width,
  quality,
}: {
  src: string
  width: number
  quality?: number
}) {
  const base = process.env.NEXT_PUBLIC_CLOUDINARY_BASE_URL
  return `${base}f_auto,q_${quality ?? 'auto'},w_${width}/${src}`
}
